var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "ce19fe73df626aa9514b9ab07070fb8ddcab3c4f"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["marketing-js@when-i-work"] = {
  id: "ce19fe73df626aa9514b9ab07070fb8ddcab3c4f"
};